import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"currency-yen, money"} maskId="square-filled-radius-0-stroke-1-IconCurrencyYen"><path d="M19.3066 3.67383L12.9648 11H17.999V12.5H12.749V14H17.999V15.5H12.749V21H11.249V15.5H5.99902V14H11.249V12.5H5.99902V11H11.0332L4.69141 3.67383L5.8252 2.69238L11.999 9.82129L18.1729 2.69238L19.3066 3.67383Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCurrencyYen;
